import React from "react";
import "../Styles/Home.css";

import Pop from "./Pop";

function About() {
  return (
    <Pop>
      <div className="home-body">
        <div className="about-me">
          <h2>About Me</h2>
          <p>
            I am a Full-Stack Developer with over 3 years of experience in
            designing and developing scalable, user-friendly web and mobile
            applications. My expertise includes HTML, CSS, Bootstrap,
            JavaScript, React.js, Python, and Django. Additionally, I have a
            solid understanding of C and C++, as well as experience with version
            control systems like Git and GitHub. I have worked on a wide range
            of projects for different clients, ensuring high-quality,
            responsive, and easily navigable applications. My ability to
            collaborate effectively with teams and individuals has allowed me to
            create seamless digital experiences that meet client expectations. I
            have also worked as a Full-Stack Developer at ZiloTech, where I
            contributed to the development and optimization of web applications,
            implementing modern technologies to enhance functionality and
            performance. My time at ZiloTech helped me refine my problem-solving
            skills and deepen my understanding of building scalable
            applications. I am passionate about continuous learning and always
            seek opportunities to expand my skill set while working on
            innovative projects. I look forward to collaborating with others to
            bring ideas to life through technology.
          </p>
        </div>
      </div>
    </Pop>
  );
}

export default About;
